import {CommonModule} from '@angular/common';
import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {
    filterNulls,
    HiddenValueWhileLoading,
    switchMapWithLoading,
    TranslatePipe,
    TranslateService,
} from '@brunata-angular/util';
import {Store} from '@ngrx/store';
import {map, Observable} from 'rxjs';
import {selectBuilding} from 'src/app/state/selectors';
import {LoadComponent} from '@brunata-angular/ui';
import {NgbActiveModal, NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {VariableAlarmsService} from '../../variable-alarms.service';
import {
    VariableAlarmTemplate,
    VariableAlarmTypeEligibility,
} from '../variable-alarm-type-eligibility.model';
import {TooltipComponent} from '@brunata-angular/ui';
import {getTemplates} from '../templates';

@Component({
    selector: 'app-select-template-or-custom-variable-alarm',
    standalone: true,
    imports: [CommonModule, TranslatePipe, LoadComponent, NgbPopover, TooltipComponent],
    templateUrl: './select-template-or-custom-variable-alarm.component.html',
    styleUrl: './select-template-or-custom-variable-alarm.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectTemplateOrCustomVariableAlarmComponent {
    private readonly store = inject(Store);
    private readonly translateService = inject(TranslateService);
    private readonly variableAlarmsService = inject(VariableAlarmsService);
    readonly activeModal = inject(NgbActiveModal);
    private readonly buildingNo$ = this.store.select(selectBuilding).pipe(
        map(state => (state.status === 'success' ? state.buildingNo : null)),
        filterNulls(),
    );
    protected readonly variableAlarmTemplates$: Observable<
        HiddenValueWhileLoading<VariableAlarmTemplate[]>
    > = this.buildingNo$.pipe(
        switchMapWithLoading(buildingNo =>
            this.variableAlarmsService
                .getEligibleVariableAlarmTypes(buildingNo)
                .pipe(
                    map((variableAlarmEligibility: VariableAlarmTypeEligibility) =>
                        getTemplates(this.translateService, variableAlarmEligibility),
                    ),
                ),
        ),
    );
    selectTemplate(template: VariableAlarmTemplate): void {
        this.activeModal.close(template);
    }
}
